import { useFormContext } from "react-hook-form";
import AuthPasswordRequirements from "./AuthPasswordRequirements";

export type Props = {
  layout?: "horizontal" | "vertical";
};

export function AuthPasswordRequirementsContainer({ layout }: Props) {
  const { watch } = useFormContext();

  const password = watch("password");

  const {
    formState: { errors },
  } = useFormContext();

  const passwordErrors = errors.password;

  const isTooShortError = passwordErrors?.type === "too_small";

  const isInvalidStringError = passwordErrors?.type === "invalid_string";

  return (
    <AuthPasswordRequirements
      password={password}
      isTooShortError={isTooShortError}
      isInvalidStringError={isInvalidStringError}
      layout={layout}
    />
  );
}

export default AuthPasswordRequirementsContainer;
